import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
// @ts-ignore
import moment from 'moment';
import {DateRange} from '@app/core/model/DateRange';
import {DATE_FORMAT_SHOW} from '@app/core/helpers/app.const';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html'
})
export class DatePickerComponent implements OnInit {

  @Output() navOut = new EventEmitter();

  @Input()
  public dateRange: DateRange;

  public options: any;

  // Based on http://www.daterangepicker.com/#options
  // Note: linkedCalendars must be false to prevent start/end year syncing
  public multiOption: any = {
    locale: {format: DATE_FORMAT_SHOW},
    showDropdowns: true,
    showWeekNumbers: true,
    showISOWeekNumbers: true,
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    timePickerIncrement: 30,
    autoApply: false,
    maxDate: moment().format(DATE_FORMAT_SHOW),
    maxSpan: {
      days: 999
    },
    ranges:
      {
        Today: [moment().subtract(1, 'days'), moment()],
        Yesterday: [moment().subtract(2, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().format(DATE_FORMAT_SHOW)],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().startOf('month')]
      },
    alwaysShowCalendars: true,
    applyButtonClasses: 'btn-default shadow-0',
    cancelClass: 'btn-success shadow-0',
    linkedCalendars: false
  };

  public singleOption: any = {
    locale: {format: DATE_FORMAT_SHOW},
    singleDatePicker: true,
    showDropdowns: true,
    showWeekNumbers: true,
    showISOWeekNumbers: true,
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    timePickerIncrement: 30,
    autoApply: true,
    maxSpan: {
      days: 365
    },
    alwaysShowCalendars: true,
    applyButtonClasses: 'btn-default shadow-0',
    cancelClass: 'btn-success shadow-0'
  };

  ngOnInit(): void {
    if (this.dateRange.single) {
      this.options = this.singleOption;
    } else {
      this.options = this.multiOption;
    }

    this.options.startDate = moment(this.dateRange.start, DATE_FORMAT_SHOW);
    this.options.endDate = moment(this.dateRange.end, DATE_FORMAT_SHOW);
  }

  public selectedDate(value: any, datepicker?: any): void {
    const start = moment(value.start).format(DATE_FORMAT_SHOW);
    const end = moment(value.end).format(DATE_FORMAT_SHOW);

    this.dateRange = new DateRange(this.dateRange.single, start, end);
    this.navOut.emit(this.dateRange);
  }

}
